import React, { Component } from "react"
import { translate } from "react-i18next"

class LanguagePicker extends Component {
  constructor(props) {
    super(props)
    this.languages = [{ Name: "English", Code: "en-GB" }, { Name: "Deutsch", Code: "de-DE" }]
    const i18nCurrentLang = this.props.i18n.language
    const currentLanguage = this.languages.find(x => x.Code === i18nCurrentLang)
    this.state = { lngName: currentLanguage.Name, lngCode: currentLanguage.Code }
  }

  // Tip: add on installed in vs code... type cdm tab, see what happens. Snippets.

  changeLanguage = lng => e => {
    e.preventDefault()
    this.setState({ lngName: lng.Name, lngCode: lng.Code })
    this.props.i18n.changeLanguage(lng.Code)
  }

  render() {
    return (
      <div className="btn-group dropup">
        <button
          type="button"
          className="btn btn-danger dropdown-toggle"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {this.state.lngName}
        </button>
        <div className="dropdown-menu">
          {this.languages.map((lng, i) => (
            <a key={i} className="dropdown-item" href="" onClick={this.changeLanguage(lng)}>
              {lng.Name}
            </a>
          ))}
        </div>
      </div>
    )
  }
}

export default translate("translations")(LanguagePicker)



// WEBPACK FOOTER //
// ./src/Components/Layout/LanguagePicker.js